module.exports = __webpack_public_path__ + "static/media/1.d7c19e6b.jpg";